import Loadable from 'react-loadable'
import LoadingIndicatorFull from './LoadingIndicatorFull.js'

const LoadableRouteCoach = Loadable({
  loader: () => import('./RouteCoach.js'),
  loading: LoadingIndicatorFull,
})

export default LoadableRouteCoach
